import { SuccessorReadiness } from '@treams/treams-network';

// Pill tint per readiness: groen 0-6 mnd, oranje nog niet, blauw long term 3-5 jaar.
export const readinessTint = (readiness: SuccessorReadiness): 'success' | 'warning' | 'info' => {
	switch (readiness) {
		case SuccessorReadiness.ReadyNow:
			return 'success';
		case SuccessorReadiness.NotReady:
			return 'warning';
		case SuccessorReadiness.LongTerm:
			return 'info';
	}
};

// Sort order: soonest first.
export const readinessOrder = (readiness: SuccessorReadiness): number => {
	switch (readiness) {
		case SuccessorReadiness.ReadyNow:
			return 0;
		case SuccessorReadiness.LongTerm:
			return 1;
		case SuccessorReadiness.NotReady:
			return 2;
	}
};

export const readinessLabelKey = (readiness: SuccessorReadiness) =>
	`analytics.talentReview.succession.readiness.${readiness}`;

export const READINESS_OPTIONS = [
	SuccessorReadiness.ReadyNow,
	SuccessorReadiness.NotReady,
	SuccessorReadiness.LongTerm,
];
